const {
  isPlainObject
} = require('lodash');
const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
  * @function evalute - evaluate pseudoContentObjectMapBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const object = await evaluateSource(source.object, content, parentContentPath, transientContext, nativeFunctions);
  if (object === undefined || !isPlainObject(object)) {
    return undefined;
  }
  const context = await evaluateSource(source.context, content, parentContentPath, transientContext, nativeFunctions);
  const result = {};
  await Promise.all(Object.keys(object).map(async key => {
    const value = object[key];
    const pseudoContent = {
      context,
      object,
      key,
      value
    };
    const resultKey = source.keyTransform === undefined ? key : await evaluateSource(source.keyTransform, pseudoContent, '', transientContext, nativeFunctions);
    const resultValue = source.valueTransform === undefined ? value : await evaluateSource(source.valueTransform, pseudoContent, '', transientContext, nativeFunctions);
    if (resultKey !== undefined && resultValue !== undefined) {
      result[resultKey] = resultValue;
    }
  }));
  return result;
};
module.exports = {
  evaluate
};